<template>
  <div class="manage-panel mb-6">
    <div class="manage-panel__header">
      <span class="manage-panel__title">{{ lang.usage }}</span>
    </div>
    <div class="manage-panel__body manage-panel__body--usage">
      <div class="manage-panel__progress">
        <div class="manage-panel__progress-left">
          <v-progress-circular
            :rotate="-90"
            :size="90"
            :width="6"
            :value="ramPercent"
            color="orange"
            class="font-weight-bold"
          >
            {{ ramPercent }}%
          </v-progress-circular>
        </div>
        <div class="manage-panel__progress-right">
          <div class="manage-panel__progress-title">{{ lang.ram }}</div>
          <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.used }}</span>
            <span class="manage-panel__progress-item-stat primary--text"
              >{{ ramUsedGb }} {{ lang.gb }}</span
            >
          </div>
          <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.available }}</span>
            <span
              class="manage-panel__progress-item-stat gray lighten-4 gray-darken-4 px-1 d-flex"
              >{{ ramTotalGb }} {{ lang.gb }}</span
            >
          </div>
        </div>
      </div>
      <div class="manage-panel__progress">
        <div class="manage-panel__progress-left">
          <v-progress-circular
            :rotate="-90"
            :size="90"
            :width="6"
            :value="cpuPercent"
            color="primary"
            class="font-weight-bold"
          >
            {{ cpuPercent }}%
          </v-progress-circular>
        </div>
        <div class="manage-panel__progress-right">
          <div class="manage-panel__progress-title">{{ lang.cpu }}</div>
          <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.used }}</span>
            <span class="manage-panel__progress-item-stat orange--text"
              >{{ cpuPercent }} %</span
            >
          </div>
          <!-- <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.available }}</span> 
            <span class="manage-panel__progress-item-stat gray lighten-4 gray-darken-4 px-1 d-flex">100 %</span>
          </div> -->
        </div>
      </div>
      <div class="manage-panel__progress">
        <div class="manage-panel__progress-left">
          <v-progress-circular
            :rotate="-90"
            :size="90"
            :width="6"
            :value="diskPercent"
            color="pink"
            class="font-weight-bold"
          >
            {{ diskPercent }}%
          </v-progress-circular>
        </div>
        <div class="manage-panel__progress-right">
          <div class="manage-panel__progress-title">{{ lang.diskSpace }}</div>
          <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.used }}</span>
            <span class="manage-panel__progress-item-stat pink--text"
              >{{ diskUsedGb }} {{ lang.gb }}</span
            >
          </div>
          <div class="manage-panel__progress-item">
            <span class="manage-panel__progress-item-title">{{ lang.available }}</span>
            <span
              class="manage-panel__progress-item-stat gray lighten-4 gray-darken-4 px-1 d-flex"
              >{{ diskTotalGb }} {{ lang.gb }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/apis/Api";

export default {
  components: {},
  props: {},
  data() {
    return {
      metrics: null,
      fetching: false,
    };
  },
  computed: {
    lang() {
      return {
        usage: this.$t("heading.hosting.usage.title"),
        cpu: "CPU",
        ram: "RAM",
        diskSpace: "Disk Space",
        used: "Used",
        available: "Available",
        gb: "GB",
      };
    },
    cpuPercent() {
      if (this.metrics === null) {
        return 0;
      }
      return Math.ceil(this.metrics.cpu_usage_percent);
    },
    ramPercent() {
      if (this.metrics === null) {
        return 0;
      }
      return Math.ceil(this.metrics.ram_usage_percent);
    },
    ramUsedGb() {
      if (this.metrics === null) {
        return 0;
      }
      return (
        Math.round((this.metrics.ram_used / 1024 / 1024) * 100) / 100
      ).toFixed(2);
    },
    ramTotalGb() {
      if (this.metrics === null) {
        return 0;
      }
      return (
        Math.round((this.metrics.ram_total / 1024 / 1024) * 100) / 100
      ).toFixed(2);
    },
    diskPercent() {
      if (this.metrics === null) {
        return 0;
      }
      return Math.ceil(this.metrics.disk_usage_percent);
    },
    diskUsedGb() {
      if (this.metrics === null) {
        return 0;
      }
      return (
        Math.round((this.metrics.disk_used / 1024 / 1024 / 1024) * 100) / 100
      ).toFixed(2);
    },
    diskTotalGb() {
      if (this.metrics === null) {
        return 0;
      }
      return (
        Math.round((this.metrics.disk_total / 1024 / 1024 / 1024) * 100) / 100
      ).toFixed(2);
    },
  },
  mounted() {
    if (!this.fetching) {
      this.loadMetrics();
    }
  },
  watch: {},
  methods: {
    loadMetrics() {
      this.fetching = true;
      Api.get(`/server/metrics/current`)
        .then((response) => {
          this.metrics = response.data.data;
        })
        .catch((error) => {
          this.$root.$emit("alert-error", Api.parseErrorMessage(error));
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
};
</script>


<style lang="scss" scoped src="./ServerManage.scss"></style>

<style lang="scss">
.manage-panel {
  .manage-panel__progress-body {
    .v-progress-circular {
      .v-progress-circular__underlay {
        stroke-width: 2px;
      }
      .v-progress-circular__overlay {
        stroke-width: 3px;
      }
    }
  }
}
</style>